module.exports = __webpack_public_path__ + "static/media/no-video.cbfd9149.svg";